const photoEnhancer = {
  UnlimitedNumberOfSheets: "Nombre d'images illimité",
  SupportAllModels: 'Prend en charge tous les modèles',
  MagnificationAllX: 'Grossissement : 1X, 2X, 4X, 8X',
  OutputImageFormatMore: "Format d'image de sortie : JPG, PNG, TIFF",
  NoWatermark: 'Sans filigrane',
  CancelAtAnytime: 'Annuler à tout moment',
  HighPriorityProcessingSpeed: 'Vitesse de traitement prioritaire',
  HitPawAIPhotoEnhancer: 'HitPaw IA Amélioration Photo',
  weekDayPrice: '$1.28€',
  WeekTotalPrice: '$8.99€',
  MonthDayPrice: '$0.63€',
  MonthTotalPrice: '$18.99€',
  YearDayPrice: '$0.36€',
  YearTotalPrice: '$129.99€',
  Day: 'Jour',
  Monthly: 'Mensuel',
  Weekly: 'Hebdomadaire',
  Yearly: 'Annuel',
};

export default photoEnhancer;
